import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight, Sparkles, Shield, Clock } from 'lucide-react';

const FinalCTA = ({ onCTAClick, spotsLeft }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-[#1A2E24]" data-testid="final-cta-section">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#2E5C41] rounded-full mb-8">
            <Sparkles className="w-4 h-4 text-[#849B89]" strokeWidth={1.5} />
            <span className="text-sm font-medium text-white">Acceso Fundadores Limitado</span>
          </div>

          {/* Headline */}
          <h2 className="font-cabinet text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
            ¿Listo para transformar tu práctica
            <span className="text-[#849B89]"> con el poder de la IA?</span>
          </h2>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-2xl mx-auto mb-10">
            Únete a los primeros nutricionistas que están revolucionando el acompañamiento de pacientes. 
            <span className="text-white font-medium"> Solo {spotsLeft} cupos disponibles</span> al precio de fundador.
          </p>

          {/* CTA Button */}
          <motion.button
            onClick={onCTAClick}
            className="group inline-flex items-center justify-center gap-3 px-10 py-5 bg-white text-[#1A2E24] text-lg font-bold rounded-full hover:bg-[#F2F4F0] transition-all duration-300 mb-8"
            whileHover={{ y: -3, scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            data-testid="cta-final"
          >
            Reservar mi cupo de fundador
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
          </motion.button>

          {/* Trust badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/60 text-sm">
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4" strokeWidth={1.5} />
              <span>30 días de garantía</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-white/30 rounded-full" />
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4" strokeWidth={1.5} />
              <span>Cancela cuando quieras</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-white/30 rounded-full" />
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4" strokeWidth={1.5} />
              <span>Precio bloqueado de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
